/**
 * Async function that waits for given amount of seconds
 *
 * @param {number} seconds Seconds to wait
 * @returns {Promise<void>} Promise that resolves when the given amount of seconds is over
 */
export async function delay(seconds: number) {
    return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
}
